/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/baby_medium'
export default icon
